// extracted by mini-css-extract-plugin
export default {"balance":"styles_balance__5DSMY","balance__num":"styles_balance__num__zfIlg","balance__text":"styles_balance__text__Gm0fg"};